/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import * as React from 'react';

/**
 * Permet de mettre à jour dynamiquement un state en fonction de la taille de l'écran
 *
 * @param width State de la largeur dynamique de l'écran
 * @param setWidth Setter du state de la largeur dynamique de l'écran
 * @param mode 'width'|'height' : Définit si le resize concerne la hauteur ou la largeur
 */
const useResizer = (
  width: number,
  setWidth: (value: number) => void,
  mode = 'width',
) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: no need
  React.useEffect(() => {
    const updateScreenWidth = () => {
      switch (mode) {
        case 'width':
          setWidth(window.innerWidth);
          break;

        case 'height':
          setWidth(window.innerHeight);
          break;

        default:
          break;
      }
    };

    window.addEventListener('resize', updateScreenWidth);

    return () => {
      window.removeEventListener('resize', updateScreenWidth);
    };
  }, [mode, width, setWidth]);
};

export default useResizer;
